import React from "react";

/**
 * Global error boundary — catches any uncaught React render error and shows
 * a friendly fallback instead of a blank page.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  reset = () => {
    this.setState({ hasError: false });
    if (typeof window !== "undefined") window.location.assign("/");
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen grid place-items-center bg-[#FAFAF9] px-4" data-testid="error-boundary">
        <div className="max-w-md text-center">
          <div className="font-mono text-6xl font-bold text-[#0EA5A4]">500</div>
          <h1 className="mt-4 font-display text-3xl font-extrabold tracking-tighter">Something went sideways.</h1>
          <p className="mt-3 text-[#4B5563]">
            We hit an unexpected error. We've logged it and you can safely go back home — your data is fine.
          </p>
          <button onClick={this.reset}
            className="mt-6 px-5 py-2.5 rounded-xl bg-[#0EA5A4] hover:bg-[#0F766E] text-white font-semibold transition-colors"
            data-testid="error-boundary-reset">
            Back to home
          </button>
        </div>
      </div>
    );
  }
}
